<div class="dr-video-container">
  <div *ngIf="isLoading" class="loading-container">
    <mat-spinner></mat-spinner>
    <p>Cargando consulta médica virtual...</p>
  </div>

  <div *ngIf="!isLoading && videoUrl" class="video-frame-container">
    <iframe 
      [src]="videoUrl" 
      class="video-iframe"
      frameborder="0"
      allowfullscreen>
    </iframe>
  </div>
  
  <div *ngIf="!isLoading && !videoUrl" class="error-container">
    <mat-icon>error</mat-icon>
    <p>Error al cargar la consulta médica virtual</p>
    <button mat-raised-button color="primary" (click)="goBack()">Volver</button>
  </div>
</div>